import { Button, CircularProgress } from '@material-ui/core';
import React from 'react';
import { UPGRADE_PLANS_CONFIG } from '../../constants/common';

const UpgradeToolsPlan = ({ handlePlanSelection, planPurchaseLoading, handleTermsOfUseClick }) => {
  const CheckIconSvg = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
        <g clip-path="url(#clip0_2550_10440)">
          <path
            d="M11.7878 6.37267L7.33282 10.8277L5.21204 8.70692"
            stroke="#FFC72C"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.3359 8.60016C16.3359 12.9278 12.8277 16.4361 8.5 16.4361C4.17234 16.4361 0.664062 12.9278 0.664062 8.60016C0.664062 4.2725 4.17234 0.764221 8.5 0.764221C12.8277 0.764221 16.3359 4.2725 16.3359 8.60016Z"
            stroke="#FFC72C"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2550_10440">
            <rect width="17" height="17" fill="white" transform="translate(0 0.0999756)" />
          </clipPath>
        </defs>
      </svg>
    );
  };
  return (
    <div className="upgrade-plan-container">
      <div className="main-cards-container">
        {UPGRADE_PLANS_CONFIG.map((item, index) => (
          <div className={`card ${index == 1 ? 'card recommended-card' : ''}`} key={index}>
            {index == 1 ? <div className="recommended-tag">RECOMMENDED</div> : null}
            <p className="type m-0">{item?.type?.toUpperCase()}</p>
            <div className="amount">
              <p className="monthly m-0 discounted-amount">
                <span className="currency m-0">{item?.currency}</span>
                <span className="monthly-amount">{item?.monthlyAmount}</span>
                &nbsp;
                <span className="mo">USD</span>
                <span className="per">/</span> <span className="mo">mo</span>
              </p>
              {/* <div className="yearly m-0">
                {item?.currency}
                {item?.yearlyAmount}/year
              </div> */}
            </div>

            <Button className="choose-plan-btn" variant="contained" onClick={() => handlePlanSelection(item?.type)}>
              {planPurchaseLoading?.[item?.type] ? <CircularProgress className="" size={24} /> : 'Start Now'}
            </Button>
            <div className="description-container">
              <div className="section">
                <CheckIconSvg />
                <p className=" m-0">
                  {' '}
                  <span>{item?.creditsPerDay}</span> Daily Credits
                </p>
              </div>
              <div className="section">
                <CheckIconSvg />
                <p className=" m-0">
                  <span>All</span> {item?.access}
                </p>
              </div>
              <div className="section">
                <CheckIconSvg />
                <p className=" m-0">
                  <span>{item?.validTill}</span> reset to credit limit
                </p>
              </div>
              <div className="section">
                <CheckIconSvg />
                <p className=" m-0">
                  <span>{item?.noOfUser}</span> User {item?.isAddMore ? '(add more for $10 USD/user)' : null}
                </p>
              </div>
              {/* <div className="section">
                <CheckIconSvg />
                <p className=" m-0">
                  <span className="">Add Credits</span> with {item?.currency}
                  {item?.addCreditWith} Day Pass
                </p>
              </div> */}
            </div>
            <p className="usage-policy  m-0">
              *Fair usage policy applies. Read{' '}
              <span
                className="terms"
                onClick={() => {
                  handleTermsOfUseClick();
                  window.open('/content-ai/terms');
                }}
              >
                terms of use
              </span>{' '}
              for more.
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpgradeToolsPlan;
